import React from 'react';

const TBX_ENV = window.__TBX_ENV__;
const IMA_SDK_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
const CAST_SENDER_URL = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
const TBX_PLAYER_URL = `${TBX_ENV.TBX_EXPERIENCE_CDN_URL}/player/${TBX_ENV.TBX_PLAYER_VERSION}/tbx-player.js`;
const UNITY_MODULE_URL = `${TBX_ENV.TBX_EXPERIENCE_CDN_URL}/player/unity_module/${TBX_ENV.TBX_PLAYER_UNITY_MODULE_VERSION}/unity-module.min.js`;
const TBX_PLAYER_CSS_URL = `${TBX_ENV.TBX_EXPERIENCE_CDN_URL}/player/${TBX_ENV.TBX_PLAYER_VERSION}/tbx-player.min.css`;

const loadLink = (href) => {
  return new Promise((resolve, reject) => {
    const styleLink = document.head.querySelector(`[href*='${href}']`);
    if (!!styleLink) {
      resolve(true);
    } else {
      const link = document.createElement('link');
      link.href = href;
      link.rel = 'stylesheet';
      link.addEventListener("error", reject);
      link.onload = () => {
        resolve(true);
      };
      document.head.insertBefore(link, document.head.firstChild);
    }
  });
}

const loadScript = (resourceURL) => {
  return new Promise((resolve, reject) => {
    const scriptTagQuery = document.body.querySelector(`script[src~='${resourceURL}']`);
    if (!!scriptTagQuery) {
      resolve(true);
    } else {
      const script = document.createElement('script');
      script.crossorigin = 'anonymous';
      script.src = resourceURL;
      script.async = false;
      script.addEventListener('error', reject);
      script.onload = () => resolve(true);
      document.body.appendChild(script);
    }
  });
}

/*const ImportExternalScript = resourceUrl => {
  const scriptTagQuery = document.body.querySelector(`script[src~='${resourceUrl}']`);
  if (!scriptTagQuery) {
    debugger;
    const script = document.createElement('script');
    script.src = resourceUrl;
    script.async = false;
    document.body.appendChild(script);
  }
};*/


const removeScript = (scriptToremove) => {
  let allsuspects = document.getElementsByTagName('script');
  for (let i = allsuspects.length; i >= 0; i--) {
    if (allsuspects[i] && allsuspects[i].getAttribute('src') !== null
      && allsuspects[i].getAttribute('src').indexOf(`${scriptToremove}`) !== -1) {
      allsuspects[i].parentNode.removeChild(allsuspects[i])
    }
  }
}


const WithPlayerScripts = (WrappedSectionComponent) => {
  const ComponentWithPlayerDeps = (props) => {
    const childProps = {
      ...props
    };
    const [tbxPlayerLoaded, setTbxPlayerLoaded] = React.useState(false);
    const [tbxPlayerCssLoaded, setTbxPlayerCssLoaded] = React.useState(false);
    const [tbxUnityModuleLoaded, setTbxUnityModuleLoaded] = React.useState(false);
    const [tbxPlayerError, setTbxPlayerError] = React.useState(null);

    React.useEffect(() => {
      loadScript(TBX_PLAYER_URL).then(() => {
        setTbxPlayerLoaded(true);
        console.info('>> TBX Player scripts loaded!');
      }).catch((e) => {
        console.error('>> loading script tbxPlayer: ', e);
        setTbxPlayerError({ code: 'playerScripts-LoadingError' })
      })

      loadLink(TBX_PLAYER_CSS_URL).then(() => {
        setTbxPlayerCssLoaded(true);
        console.info('>> TBX Player css scripts loaded!');
      }).catch((e) => {
        console.error('>> loading script tbxPlayer css: ', e);
        setTbxPlayerError({ code: 'playerScripts-LoadingError' })
      })

      loadScript(UNITY_MODULE_URL).then(() => {
        setTbxUnityModuleLoaded(true)
        console.info('>> TBX UnityModule scripts loaded!');
      }).catch((e) => {
        console.error('>> loading script Unity Module: ', e);
        setTbxPlayerError({ code: 'unityModuleScripts-LoadingError' })
      })

      loadScript(IMA_SDK_URL);
      loadScript(CAST_SENDER_URL);

    }, []);

    return (
      <WrappedSectionComponent {...childProps} playerScriptsLoaded={(tbxPlayerLoaded && tbxPlayerCssLoaded && tbxUnityModuleLoaded)} playerScriptsError={tbxPlayerError} />
    );
  }

  return ComponentWithPlayerDeps;
}

export default WithPlayerScripts;